import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { ReactComponent as CheckIcon } from '../../../../assets/icons/check_purple_icon.svg';
import { getActions, navigateToView } from "store/appTrack/actions";
import { useNavigate } from "react-router-dom";
import { claimActive, updateFormField } from "store/forms/actions";
import { isAuditor, isCommittee } from "utils";

const ActionList = (props) =>{
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const privileges = useSelector(state => state.user.privileges);
    const view = useSelector(state => state.appTrack.permissions.view);
    const edit = useSelector(state => state.appTrack.permissions.edit);
    const cancel = useSelector(state => state.appTrack.permissions.cancel);
    const groups = useSelector(state => state.user.groups);
    const variables = useSelector(state => state.appTrack.variables);
    const user = useSelector(state => state.user);
    const actions = useSelector(state => state.appTrack.permissions);
    const approveApp = actions?.approveApplication;
    const rejectApp = actions?.rejectApplication;   
    const finalApproveApp = actions?.finalApproveApplication;
    const withdrawApp = actions?.withdrawApplication;   

    // Check if user is auditor
    const isUserAuditor = isAuditor(groups);
    // Check if user is committee
    const isUserCommittee = isCommittee(groups);

    useEffect(() => {
        dispatch(getActions(props.id)); 
    }, [])

    const onView = (value) => {
      props.open(false);
      navigateToView(navigate, props.id);
    }

    const onEdit = (value) => {
      dispatch(
        updateFormField({
          group: 'task',
          key: 'processInstanceId',
          value: props.id
        })
      ); 
      dispatch(
        updateFormField({
          group: 'carrier',
          key: 'viewMode',
          value: false
        })
      );
      dispatch(claimActive(navigate, props.id));
    }

    const onApprove = () => {
      props.open(false);
      // auditor modal approve outcome
      if (props.onOpenSubmitModal) {
        props.onOpenSubmitModal('approveAuditor');
      }
    }

    const onFinalApprove = () => {
      props.open(false);
      // committee modal final approve outcome
      if (props.onOpenSubmitModal) {
        props.onOpenSubmitModal('finalApproveCommittee');
      }
    }

    const onReject = () => {
      props.open(false);
      // auditor modal reject outcome
      if (props.onOpenSubmitModal) {
        props.onOpenSubmitModal('rejectAuditor');
      }
    }

    const onWithdraw = () => {
      props.open(false);
      // committee modal withdraw outcome
      if (props.onOpenSubmitModal) {
        props.onOpenSubmitModal('withdrawCommittee');
      }
    }

    const onCancel = () => {
      props.open(false)
      props.setCancelModal(true)
    }

    const locales = useSelector(state => state.forms?.localeStrings);

    return(
        <div id={`action-list-for-${props.id}`} className="popover-container">
            {/* view action*/}
            {view ? (
              <div id="action-button-view" className="popover-item" onClick={() => onView(props.id)}>
                Προβολή <CheckIcon className="check"/>
              </div>
            ) : null}
            
            {/* approve- reject actions*/}
            {isUserAuditor ? (
              <>
              {isUserAuditor && approveApp ? (
                <div id="action-button-approve" className="popover-item approve-action" onClick={() => onApprove(props.id)}>
                  <span>Έγκριση <CheckIcon className="check"/></span>
                </div>
              ) : null}

              {isUserAuditor && rejectApp ? (
                <div id="action-button-reject" className="popover-item reject-action" onClick={() => onReject(props.id)}>
                  <span>Απόρριψη <CheckIcon className="check"/></span>
                </div>
              ) : null}
              </>
            ) : (
              /* edit an exoyn permissions */
              edit ? (
                <div id="action-button-edit" className="popover-item" onClick={() => onEdit(props.id)}>
                  <span>Επεξεργασία <CheckIcon className="check"/></span>
                </div>
              ) : null
            )}
            
            {/* approve- reject actions*/}
            {isUserCommittee ? (
              <>
              {finalApproveApp ? (
                <div id="action-button-finalapprove" className="popover-item finalapprove-action" onClick={() => onFinalApprove(props.id)}>
                  <span>Ένταξη <CheckIcon className="check"/></span>
                </div>
              ) : null}

              {withdrawApp ? (
                <div id="action-button-withdraw" className="popover-item withdraw-action" onClick={() => onWithdraw(props.id)}>
                  <span>Απένταξη <CheckIcon className="check"/></span>
                </div>
              ) : null}
              </>
            ) : null}

            {/* Cancel action*/}
            {cancel ? (
              <div id="action-button-cancel" className="popover-item" onClick={() => onCancel(props.id)}>
                <span>Ακύρωση <CheckIcon className="check"/></span>
              </div>
            ) : null}
        </div>
    )
}

export default ActionList;